import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { SkewBox } from "../../components/page/skew";
import { GlobalMedicNav } from "../../components/global-medic/global-medic-nav";

export const GlobalCommunity = () => {

    const navigateTo = useNavigate();

    return (
        <div className="global-medic-container">
            <SkewBox
                title={"GLOBAL COMMUNITIES"}
                background={"/media/global-medic.png"}
            />
            <GlobalMedicNav active={'comm'} />
            <div className="flx-rw e-jt c-al mrg-i-3">
                <button
                    className="add-button gl-btn"
                    onClick={() => navigateTo("/globalmedic/createblog")}
                >
                    <FontAwesomeIcon icon={faUserPlus} color='#2a88cb' className='add-ico' />
                    <span className='st-cap'>New Community</span>

                </button>
            </div>

        </div>
    );
}